module.exports = __webpack_public_path__ + "static/bg-38613543c07cf2c51e84f17fbd1182b1.svg";